export const hasPermission = (
  permissionMap,
  moduleId,
  permissionId
) => {
  return permissionMap?.[moduleId]?.has(permissionId);
};